const sanitizeFileName = (fileName) => {
  if (!fileName) return fileName;
  
  const maxFileName = 255;
  
  let fileParts = fileName.split(".");
  let fileExtension = fileParts.pop();
  let sanitizedName = fileParts.join(".").replace(/[^A-Za-z0-9]/g, "_");
  if (sanitizedName.length > maxFileName) {
    sanitizedName = sanitizedName.substring(0, 200);
  }
  
  sanitizedName = `${sanitizedName}.${fileExtension}`;
  
  return sanitizedName;
};

export default sanitizeFileName;